// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__Z7nqA","title":"FrontImage_title__28bLN"};